namespace RedBullMOBILE360.CustomerCare {
    export interface ManualResumeFraudCasesForm {
        Msisdn: Serenity.StringEditor;
        IdNumber: Serenity.StringEditor;
    }

    export class ManualResumeFraudCasesForm extends Serenity.PrefixedContext {
        static formKey = 'CustomerCare.ManualResumeFraudCases';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ManualResumeFraudCasesForm.init)  {
                ManualResumeFraudCasesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(ManualResumeFraudCasesForm, [
                    'Msisdn', w0,
                    'IdNumber', w0
                ]);
            }
        }
    }
}
